<template>
  <div class="container">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <van-cell title="老师" is-link :value="teacherText" @click="chooseTeacher" />
          <van-cell
            title="班级"
            is-link
            value-class="van-ellipsis"
            :value="params.className || '请选择'"
            @click="chooseClass"
          />
          <div class="nav-wrapper">
            <div class="nav-title">时间区间</div>
            <div class="date-box" @click="chooseCalendar">
              {{ params.startDate | formatDatetime('yyyy-MM-dd') }}~{{
                params.endDate | formatDatetime('yyyy-MM-dd')
              }}
            </div>
          </div>
        </div>
        <van-row class="footer" gutter="8">
          <van-col span="12">
            <van-button block square round hairline @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm"> 确认 </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
function getInitParams() {
  let startD = new Date();
  startD.setDate(startD.getDate() - 1);
  return {
    campusIds: [],
    campusList: [],
    classId: '',
    className: '',
    curriculumId: '',
    teacherList: [],
    teacherIds: [],
    startDate: app.tool.date.formatDatetime(startD, 'yyyy-MM-dd'),
    endDate: app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd'),
  };
}

export default {
  name: '',
  data() {
    return {
      visible: false,
      params: getInitParams(),
    };
  },
  computed: {
    teacherText: function () {
      let cps = this.params.teacherList,
        text = '请选择';
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个老师`;
      }
      return text;
    },
  },
  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },

    // 选择老师
    async chooseTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.teacherIds,
        list: this.params.teacherList,
      });
      this.params.teacherIds = res.ids;
      this.params.teacherList = res.list;
    },
    // 选择班级
    async chooseClass() {
      let res = await app.x3.side.xsClass({
        id: this.params.classId,
        params: {
          campusIds: this.params.campusIds,
          campusList: this.params.campusList,
          classStatus: '',
          curriculumIds: [this.params.curriculumId],
        },
        config: {
          radio: true,
          enableFilter: false,
        },
        filter: {
          enableCampusFilter: false,
        }
      });
      this.params.classId = res ? res.id : '';
      this.params.className = res ? res.className : '';
    },
    // 显示日期选择框
    chooseCalendar() {
      // 这个筛选在点名排课列表筛选，添加试听选排课筛选复用
      // 关于快速选择日期范围的，两个地方有点差异
      // 点名排课列表筛选快速范围往后推日期，添加试听选排课筛选往前推
      // 所以这里要用参数有些差异
      let { config, quickRangeConfig } = this.$route.meta.options || {};
      let attrs = { allowSameDay: true, maxRange: '' };
      if (config && config.maxDate) {
        attrs.maxDate = config.maxDate;
      }

      app.x3.picker
        .dateRange({
          startDate: new Date(this.params.startDate),
          endDate: new Date(this.params.endDate),
          config: quickRangeConfig,
          attrs: attrs,
        })
        .then(res => {
          Object.assign(this.params, res);
        })
        .catch(() => {
          console.log('取消选择或报错了');
        });
    },
    // 重置
    reset() {
      this.params = getInitParams();
    },
    doneAnima() {
      this.$router.back();
      return new Promise(rsv => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params: {
              ...this.params,
              startDate: app.tool.date.formatDatetime(this.params.startDate, 'yyyy-MM-dd'),
              endDate: app.tool.date.formatDatetime(this.params.endDate, 'yyyy-MM-dd'),
            },
          })
        )
      );
    },
  },
  created() {
    this.prevInit();
  },
  beforeDestroy() {},
  watch: {
    '$vxRoute.vx_action': function (nv, ov) {
      // console.log(nv);
      if (nv == 'vx-out') {
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(var(--black-rgb), 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;
      .nav-wrapper {
        margin-left: calc(var(--gap) * 16);
        .nav-title {
          padding: calc(var(--gap) * 14) calc(var(--gap) * 17) calc(var(--gap) * 8) 0;
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
        }
        .date-box {
          margin-right: calc(var(--gap) * 18);
          height: calc(var(--w) * 36);
          line-height: calc(var(--w) * 36);
          text-align: center;
          border-radius: var(--radius-base);
          border: 1px solid var(--g4);
          cursor: pointer;
        }
      }
    }
    .footer {
      padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
      height: calc(var(--w) * 58);
    }
  }
}
</style>